import React from "react";
import PropTypes from "prop-types";
import { Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"; // Ícono para dropdown

function CustomLink({ to, children, hasDropdown = false, isHovered = false }) {
  const theme = useTheme();

  return (
    <Button
      component={Link}
      to={to}
      sx={{
        fontWeight: "bold",
        textTransform: "uppercase",
        color: isHovered
          ? theme.palette.highlight.main // Color naranja cuando está hover
          : theme.palette.primary.main, // Color normal
        display: "flex",
        alignItems: "center",
        gap: "4px",
        "&:hover": {
          backgroundColor: "transparent", // Sin fondo
          color: theme.palette.highlight.main, // Naranja
        },
      }}
    >
      {children}
      {hasDropdown && (
        <Box
          component="span"
          sx={{
            display: "flex",
            alignItems: "center",
            color: isHovered
              ? theme.palette.highlight.main
              : theme.palette.primary.main,
            transform: isHovered ? "rotate(180deg)" : "rotate(0deg)", // Rotación condicional
            transition: "transform 0.3s ease-in-out", // Transición suave
          }}
        >
          <KeyboardArrowDownIcon sx={{ fontSize: "18px" }} />
        </Box>
      )}
    </Button>
  );
}

CustomLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  hasDropdown: PropTypes.bool,
  isHovered: PropTypes.bool,
};

export default CustomLink;
